
import React from "react";
import StringUtil from "core/util/StringUtil";
import ICourseFragmentProps from "../course/ICourseFragmentProps";

import { RenderProgramTrackEager, RenderProgramTrackLazy } from "./ProgramTrack";
import { ViewProvider } from "core/decorators/View";



export default (props: ICourseFragmentProps) => {
	const { course } = props;

	if (!course) {
		return null;
	}

	const id = StringUtil.toInteger(course.contentId, 0);
	if (id < 1) {
		return null;
	}


	const isLazy = props && props.lazyLoad && !props.searchText; 

	const render = isLazy ? (
		<RenderProgramTrackLazy courseFramentPops={props} courseID={id} />
	) : (
		<ViewProvider keyPrefix="overview.">
			<RenderProgramTrackEager courseFramentPops={props} courseID={id} />
		</ViewProvider>
	);
	
	return render;
};



// WEBPACK FOOTER //
// ./src/panels/catalog/fragments/overview/ProgramOverview.tsx